

// import React, { useState } from 'react'
// import { toast, ToastContainer } from 'react-toastify'
// import 'react-toastify/dist/ReactToastify.css'
// import { motion, AnimatePresence } from 'framer-motion'
// import { Upload, FileText, Zap, Shield, TrendingUp, CheckCircle, AlertCircle, X, Download, Eye } from 'lucide-react'
// import authHeader from '../../Services/AuthHeader'
// import cookie from 'react-cookies'
// import axios from 'axios'
// function BulkRecharge() {
//   const [file, setFile] = useState(null)
//   const [fileName, setFileName] = useState('')
//   const [isDragging, setIsDragging] = useState(false)
//   const [loading, setLoading] = useState(false)
//   const [processedCount, setProcessedCount] = useState(0)
//   const [showPreview, setShowPreview] = useState(false)

//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0]
//     validateAndSetFile(selectedFile)
//   }

//   const validateAndSetFile = (selectedFile) => {
//     if (selectedFile) {
//       if (selectedFile.type === 'text/csv' || selectedFile.name.endsWith('.csv')) {
//         setFile(selectedFile)
//         setFileName(selectedFile.name)
//         toast.success('File validated successfully')
//       } else {
//         toast.error('Please upload a CSV file only')
//         setFile(null)
//         setFileName('')
//       }
//     }
//   }

//   const handleDragOver = (e) => {
//     e.preventDefault()
//     setIsDragging(true)
//   }

//   const handleDragLeave = () => {
//     setIsDragging(false)
//   }

//   const handleDrop = (e) => {
//     e.preventDefault()
//     setIsDragging(false)
//     const droppedFile = e.dataTransfer.files[0]
//     validateAndSetFile(droppedFile)
//   }

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault()
//   //   if (!file) {
//   //     toast.error('Please select a CSV file first')
//   //     return
//   //   }

//   //   setLoading(true)
//   //   setProcessedCount(0)
    
//   //   const formData = new FormData()
//   //   formData.append('file', file)
    
//   //   try {
//   //     const token = cookie.load('token');
//   //     const response = await fetch(`/api/merchant/bulk-vtu`, {
//   //       method: 'POST',
//   //       headers: authHeader(),
//   //       body: formData
//   //     })
      
//   //     const result = await response.json()
      
//   //     if (result.status === '2000') {
//   //       toast.success(result.data.description)
//   //     } else {
//   //       toast.error(result.description || 'Failed to process bulk recharge')
//   //     }
//   //   } catch (error) {
//   //     toast.error('An error occurred while processing the file')
//   //   } finally {
//   //     setLoading(false)
//   //     setProcessedCount(100)
//   //   }
//   // }
//  // Update path accordingly
  
//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!file) {
//       toast.error('Please select a CSV file first');
//       return;
//     }
  
//     setLoading(true);
//     setProcessedCount(0);
  
//     const formData = new FormData();
//     formData.append('file', file);
  
//     try {
//       const response = await axios.post('/api/merchant/bulk-vtu', formData, {
//         headers: {
//           ...authHeader(), // Include your auth header
//           'Content-Type': 'multipart/form-data' 
//         }
//       });
  
//       const result = response.data;
      
//       if (result.status === '2000') {
//         toast.success(result.data.description);
//       } else {
//         toast.error(result.description || 'Failed to process bulk recharge');
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       toast.error('An error occurred while processing the file');
//     } finally {
//       setLoading(false);
//       setProcessedCount(100);
//     }
//   };
  
//   const clearFile = () => {
//     setFile(null)
//     setFileName('')
//     setProcessedCount(0)
//   }

//   const downloadTemplate = () => {
//     toast.info('CSV template downloaded')
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
//       {/* Header Section */}
//       <div className="bg-white/80 backdrop-blur-sm border-b border-slate-200/60 sticky top-0 z-40">
//         <div className="max-w-7xl mx-auto px-6 py-6">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center space-x-4">
//               <div className="w-12 h-12 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-xl flex items-center justify-center">
//                 <Zap className="w-6 h-6 text-white" />
//               </div>
//               <div>
//                 <h1 className="text-3xl font-bold bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent">
//                   Bulk Recharge
//                 </h1>
//                 <p className="text-slate-600 mt-1">Process multiple recharges simultaneously</p>
//               </div>
//             </div>
//             {/* <div className="flex items-center space-x-3">
//               <motion.button
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.95 }}
//                 onClick={downloadTemplate}
//                 className="flex items-center space-x-2 px-4 py-2 text-slate-700 hover:text-indigo-600 transition-colors"
//               >
//                 <Download className="w-4 h-4" />
//                 <span className="font-medium">Template</span>
//               </motion.button>
//             </div> */}
//           </div>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="max-w-7xl mx-auto px-6 py-12">
//         <div className="grid lg:grid-cols-3 gap-8">
//           {/* Upload Section */}
//           <div className="lg:col-span-2">
//             <motion.div 
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-200/60 overflow-hidden"
//             >
//               <div className="p-8">
//                 <div className="flex items-center space-x-3 mb-6">
//                   <div className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center">
//                     <Upload className="w-4 h-4 text-indigo-600" />
//                   </div>
//                   <h2 className="text-xl font-semibold text-slate-900">Upload CSV File</h2>
//                 </div>

//                 {/* Upload Area */}
//                 <motion.div 
//                   whileHover={{ scale: 1.01 }}
//                   whileTap={{ scale: 0.99 }}
//                   className={`relative border-2 border-dashed rounded-2xl p-12 text-center cursor-pointer transition-all duration-300 ${
//                     isDragging 
//                       ? 'border-indigo-400 bg-gradient-to-br from-indigo-50 to-blue-50' 
//                       : file 
//                         ? 'border-emerald-300 bg-gradient-to-br from-emerald-50 to-green-50' 
//                         : 'border-slate-300 hover:border-indigo-300 hover:bg-slate-50/50'
//                   }`}
//                   onDragOver={handleDragOver}
//                   onDragLeave={handleDragLeave}
//                   onDrop={handleDrop}
//                   onClick={() => document.getElementById('fileInput').click()}
//                 >
//                   <input
//                     type="file"
//                     id="fileInput"
//                     accept=".csv"
//                     className="hidden"
//                     onChange={handleFileChange}
//                   />

//                   <AnimatePresence mode="wait">
//                     {file ? (
//                       <motion.div
//                         key="file-selected"
//                         initial={{ opacity: 0, scale: 0.8 }}
//                         animate={{ opacity: 1, scale: 1 }}
//                         exit={{ opacity: 0, scale: 0.8 }}
//                         className="flex flex-col items-center"
//                       >
//                         <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
//                           <CheckCircle className="w-8 h-8 text-emerald-600" />
//                         </div>
//                         <h3 className="text-lg font-semibold text-slate-900 mb-2">{fileName}</h3>
//                         <p className="text-slate-600 mb-4">File ready for processing</p>
//                         <div className="flex items-center space-x-3">
//                           <button
//                             onClick={(e) => {
//                               e.stopPropagation()
//                               setShowPreview(true)
//                             }}
//                             className="flex items-center space-x-2 px-4 py-2 text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors"
//                           >
//                             <Eye className="w-4 h-4" />
//                             <span>Preview</span>
//                           </button>
//                           <button
//                             onClick={(e) => {
//                               e.stopPropagation()
//                               clearFile()
//                             }}
//                             className="flex items-center space-x-2 px-4 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
//                           >
//                             <X className="w-4 h-4" />
//                             <span>Remove</span>
//                           </button>
//                         </div>
//                       </motion.div>
//                     ) : (
//                       <motion.div
//                         key="upload-prompt"
//                         initial={{ opacity: 0, scale: 0.8 }}
//                         animate={{ opacity: 1, scale: 1 }}
//                         exit={{ opacity: 0, scale: 0.8 }}
//                         className="flex flex-col items-center"
//                       >
//                         <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mb-4">
//                           <Upload className="w-8 h-8 text-slate-400" />
//                         </div>
//                         <h3 className="text-lg font-semibold text-slate-900 mb-2">
//                           Drop your CSV file here
//                         </h3>
//                         <p className="text-slate-600 mb-4">or click to browse from your device</p>
//                         <div className="flex items-center space-x-2 text-sm text-slate-500">
//                           <span>Supports CSV files up to 10MB</span>
//                         </div>
//                       </motion.div>
//                     )}
//                   </AnimatePresence>
//                 </motion.div>

//                 {/* Processing Button */}
//                 <motion.div 
//                   initial={{ opacity: 0 }}
//                   animate={{ opacity: 1 }}
//                   transition={{ delay: 0.2 }}
//                   className="mt-8"
//                 >
//                   <button
//                     onClick={handleSubmit}
//                     disabled={!file || loading}
//                     className={`w-full py-4 px-6 rounded-xl font-semibold text-white transition-all duration-200 ${
//                       !file || loading
//                         ? 'bg-slate-300 cursor-not-allowed'
//                         : 'bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5'
//                     }`}
//                   >
//                     {loading ? (
//                       <div className="flex items-center justify-center space-x-3">
//                         <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
//                         <span>Processing... {Math.round(processedCount)}%</span>
//                       </div>
//                     ) : (
//                       'Process Bulk Recharge'
//                     )}
//                   </button>
//                 </motion.div>
//               </div>

//               {/* Progress Bar */}
//               {loading && (
//                 <div className="px-8 pb-8">
//                   <div className="bg-slate-200 rounded-full h-2 overflow-hidden">
//                     <motion.div
//                       className="bg-gradient-to-r from-indigo-500 to-purple-500 h-full rounded-full"
//                       initial={{ width: 0 }}
//                       animate={{ width: `${processedCount}%` }}
//                       transition={{ duration: 0.5 }}
//                     />
//                   </div>
//                 </div>
//               )}
//             </motion.div>
//           </div>

//           {/* Side Panel */}
//           <div className="space-y-6">
//             {/* Stats Cards */}
//             {/* <motion.div 
//               initial={{ opacity: 0, x: 20 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ delay: 0.1 }}
//               className="bg-white rounded-2xl p-6 shadow-lg shadow-slate-200/50 border border-slate-200/60"
//             >
//               <h3 className="font-semibold text-slate-900 mb-4">Quick Stats</h3>
//               <div className="space-y-4">
//                 <div className="flex items-center justify-between">
//                   <span className="text-slate-600">Today's Processed</span>
//                   <span className="font-semibold text-slate-900">2,847</span>
//                 </div>
//                 <div className="flex items-center justify-between">
//                   <span className="text-slate-600">Success Rate</span>
//                   <span className="font-semibold text-emerald-600">99.2%</span>
//                 </div>
//                 <div className="flex items-center justify-between">
//                   <span className="text-slate-600">Avg. Speed</span>
//                   <span className="font-semibold text-blue-600">1.2s/txn</span>
//                 </div>
//               </div>
//             </motion.div> */}

//             {/* Format Guide */}
//             <motion.div 
//               initial={{ opacity: 0, x: 20 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ delay: 0.2 }}
//               className="bg-white rounded-2xl p-6 shadow-lg shadow-slate-200/50 border border-slate-200/60"
//             >
//               <div className="flex items-center space-x-3 mb-4">
//                 <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
//                   <FileText className="w-4 h-4 text-blue-600" />
//                 </div>
//                 <h3 className="font-semibold text-slate-900">CSV Format</h3>
//               </div>
//               <div className="space-y-3 text-sm">
//                 <div className="flex items-center space-x-2">
//                   <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
//                   <span className="text-slate-700"><strong>phone_number</strong> (required)</span>
//                 </div>
//                 <div className="flex items-center space-x-2">
//                   <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
//                   <span className="text-slate-700"><strong>amount</strong> (required)</span>
//                 </div>
//                 <div className="flex items-center space-x-2">
//                   <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
//                   <span className="text-slate-700"><strong>network</strong> (required)</span>
//                 </div>
//                 <div className="flex items-center space-x-2">
//                   <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
//                   <span className="text-slate-700"><strong>customer reference</strong> (required)</span>
//                 </div>
//               </div>
//               <div className="mt-4 p-3 bg-slate-50 rounded-lg">
//                 <p className="text-xs text-slate-600">
//                   Example: +2348012345678,1000,MTN
//                 </p>
//               </div>
//             </motion.div>

//             {/* Security Info */}
//             <motion.div 
//               initial={{ opacity: 0, x: 20 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ delay: 0.3 }}
//               className="bg-gradient-to-br from-emerald-50 to-green-50 rounded-2xl p-6 border border-emerald-200/60"
//             >
//               <div className="flex items-center space-x-3 mb-3">
//                 <Shield className="w-5 h-5 text-emerald-600" />
//                 <h3 className="font-semibold text-emerald-900">Secure Processing</h3>
//               </div>
//               <p className="text-sm text-emerald-800">
//                 All uploads are encrypted and processed securely. Files are automatically deleted after processing.
//               </p>
//             </motion.div>
//           </div>
//         </div>
//       </div>

//       {/* Toast Container */}
//       <ToastContainer 
//         position="top-right" 
//         autoClose={4000}
//         hideProgressBar={false}
//         newestOnTop
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="light"
//         toastClassName="!bg-white !text-slate-900 !shadow-xl !border !border-slate-200"
//       />
//     </div>
//   )
// }

// export default BulkRecharge

import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { motion, AnimatePresence } from 'framer-motion';
import { 
  Upload, FileText, Zap, Shield, 
  TrendingUp, CheckCircle, AlertCircle, 
  X, Download, Eye, Mail, Key, User 
} from 'lucide-react';
import authHeader from '../../Services/AuthHeader';
import cookie from 'react-cookies';

function BulkRecharge() {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [isDragging, setIsDragging] = useState(false);
  const [loading, setLoading] = useState(false);
  const [processedCount, setProcessedCount] = useState(0);
  const [showPreview, setShowPreview] = useState(false);
  const [merchantEmail, setMerchantEmail] = useState('');
  const [merchantSecret, setMerchantSecret] = useState('');

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    validateAndSetFile(selectedFile);
  };

  const validateAndSetFile = (selectedFile) => {
    if (selectedFile) {
      if (selectedFile.type === 'text/csv' || selectedFile.name.endsWith('.csv')) {
        setFile(selectedFile);
        setFileName(selectedFile.name);
        toast.success('File validated successfully');
      } else {
        toast.error('Please upload a CSV file only');
        setFile(null);
        setFileName('');
      }
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const droppedFile = e.dataTransfer.files[0];
    validateAndSetFile(droppedFile);
  };

  const isFormValid = () => {
    return file && merchantEmail.trim() && merchantSecret.trim();
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!file) {
      toast.error('Please select a CSV file first');
      return;
    }

    if (!merchantEmail.trim()) {
      toast.error('Please enter your merchant email address');
      return;
    }

    if (!validateEmail(merchantEmail)) {
      toast.error('Please enter a valid email address');
      return;
    }

    if (!merchantSecret.trim()) {
      toast.error('Please enter your merchant secret');
      return;
    }
  
    setLoading(true);
    setProcessedCount(0);
  
    const formData = new FormData();
    formData.append('file', file);
  
    try {
      const response = await fetch(
        `/api/merchant/bulk-vtu?emailAddress=${merchantEmail}`,
        {
          method: 'POST',
          headers: {secret: merchantSecret},
          body: formData
        }
      );
  
      const result = await response.json();
      
      if (result.status === '2000') {
        toast.success(result.data.description || 'Bulk recharge processed successfully');
        // Reset form on success
        setFile(null);
        setFileName('');
        setMerchantEmail('');
        setMerchantSecret('');
      } else {
        toast.error(result.description || 'Failed to process bulk recharge');
      }
    } catch (error) {
      console.error('Error:', error);
      if (error.response) {
        toast.error(error.response.data?.description || 'Server error occurred');
      } else if (error.request) {
        toast.error('Network error - please check your connection');
      } else {
        toast.error('An error occurred while processing the file');
      }
    } finally {
      setLoading(false);
      setProcessedCount(100);
    }
  };
  
  const clearFile = () => {
    setFile(null);
    setFileName('');
    setProcessedCount(0);
  };

  const downloadTemplate = () => {
    toast.info('CSV template downloaded');
  };

  return (
    <div className="min-h-screen shadow-md mt-5">
      {/* Professional Header Section */}
      <div className="bg-white/90 backdrop-blur-md border-b border-slate-200/80 shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="w-14 h-14 bg-gradient-to-br from-blue-300 via-blue-600 to-blue-800 rounded-2xl flex items-center justify-center shadow-lg">
                <Zap className="w-7 h-7 text-white" />
              </div>
              <div>
                <h1 className="text-4xl font-bold bg-gradient-to-r from-slate-900 via-slate-800 to-slate-700 bg-clip-text text-transparent">
                  Bulk Recharge 
                </h1>
                <p className="text-slate-600 mt-1 text-lg">Merchants-grade bulk recharge processing</p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="px-4 py-2 bg-emerald-50 border border-emerald-200 rounded-full">
                <span className="text-emerald-700 font-medium text-sm">Secure Processing</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid lg:grid-cols-3 gap-8">
          {/* Upload Section */}
          <div className="lg:col-span-2">
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="bg-white rounded-3xl shadow-2xl shadow-slate-200/60 border border-slate-200/80 overflow-hidden"
            >
              <div className="p-10">
                {/* Merchant Credentials Section */}
                <div className="mb-10">
                  <div className="flex items-center space-x-3 mb-8">
                    <div className="w-10 h-10 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-xl flex items-center justify-center">
                      <User className="w-5 h-5 text-indigo-600" />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-900">Merchant Authentication</h2>
                  </div>

                  <div className="grid md:grid-cols-2 gap-6">
                    {/* Merchant Email Input */}
                    <div className="space-y-3">
                      <label className="flex items-center space-x-2 text-sm font-semibold text-slate-700">
                        <Mail className="w-4 h-4 text-slate-500" />
                        <span>Merchant Email Address</span>
                        <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <input
                          type="email"
                          value={merchantEmail}
                          onChange={(e) => setMerchantEmail(e.target.value)}
                          placeholder="Enter your merchant email"
                          className={`w-full px-4 py-4 border-2 rounded-xl bg-slate-50/50 transition-all duration-200 focus:outline-none focus:ring-0 ${
                            merchantEmail && !validateEmail(merchantEmail)
                              ? 'border-red-300 focus:border-red-400 bg-red-50/30'
                              : merchantEmail && validateEmail(merchantEmail)
                              ? 'border-emerald-300 focus:border-emerald-400 bg-emerald-50/30'
                              : 'border-slate-300 focus:border-indigo-400 focus:bg-white'
                          }`}
                        />
                        {merchantEmail && (
                          <div className="absolute right-4 top-1/2 transform -translate-y-1/2">
                            {validateEmail(merchantEmail) ? (
                              <CheckCircle className="w-5 h-5 text-emerald-500" />
                            ) : (
                              <AlertCircle className="w-5 h-5 text-red-500" />
                            )}
                          </div>
                        )}
                      </div>
                      {merchantEmail && !validateEmail(merchantEmail) && (
                        <p className="text-sm text-red-600">Please enter a valid email address</p>
                      )}
                    </div>

                    {/* Merchant Secret Input */}
                    <div className="space-y-3">
                      <label className="flex items-center space-x-2 text-sm font-semibold text-slate-700">
                        <Key className="w-4 h-4 text-slate-500" />
                        <span>Merchant Secret</span>
                        <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <input
                          type="password"
                          value={merchantSecret}
                          onChange={(e) => setMerchantSecret(e.target.value)}
                          placeholder="Enter your merchant secret"
                          className={`w-full px-4 py-4 border-2 rounded-xl bg-slate-50/50 transition-all duration-200 focus:outline-none focus:ring-0 ${
                            merchantSecret.trim()
                              ? 'border-emerald-300 focus:border-emerald-400 bg-emerald-50/30'
                              : 'border-slate-300 focus:border-indigo-400 focus:bg-white'
                          }`}
                        />
                        {merchantSecret.trim() && (
                          <div className="absolute right-4 top-1/2 transform -translate-y-1/2">
                            <CheckCircle className="w-5 h-5 text-emerald-500" />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* File Upload Section */}
                <div>
                  <div className="flex items-center space-x-3 mb-8">
                    <div className="w-10 h-10 bg-gradient-to-br from-purple-100 to-indigo-100 rounded-xl flex items-center justify-center">
                      <Upload className="w-5 h-5 text-indigo-600" />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-900">Upload CSV File</h2>
                  </div>

                  {/* Upload Area */}
                  <motion.div 
                    whileHover={{ scale: 1.01 }}
                    whileTap={{ scale: 0.99 }}
                    className={`relative border-2 border-dashed rounded-3xl p-16 text-center cursor-pointer transition-all duration-300 ${
                      isDragging 
                        ? 'border-indigo-400 bg-gradient-to-br from-indigo-50 to-blue-50 shadow-lg' 
                        : file 
                          ? 'border-emerald-300 bg-gradient-to-br from-emerald-50 to-green-50 shadow-lg' 
                          : 'border-slate-300 hover:border-indigo-300 hover:bg-slate-50/70 hover:shadow-md'
                    }`}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    onClick={() => document.getElementById('fileInput').click()}
                  >
                    <input
                      type="file"
                      id="fileInput"
                      accept=".csv"
                      className="hidden"
                      onChange={handleFileChange}
                    />

                    <AnimatePresence mode="wait">
                      {file ? (
                        <motion.div
                          key="file-selected"
                          initial={{ opacity: 0, scale: 0.8 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.8 }}
                          className="flex flex-col items-center"
                        >
                          <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mb-6">
                            <CheckCircle className="w-10 h-10 text-emerald-600" />
                          </div>
                          <h3 className="text-xl font-bold text-slate-900 mb-3">{fileName}</h3>
                          <p className="text-slate-600 mb-6 text-lg">Ready for secure processing</p>
                          <div className="flex items-center space-x-4">
                            <button
                              onClick={(e) => {
                                e.stopPropagation()
                                setShowPreview(true)
                              }}
                              className="flex items-center space-x-2 px-6 py-3 text-indigo-600 hover:bg-indigo-50 rounded-xl transition-colors font-medium"
                            >
                              <Eye className="w-5 h-5" />
                              <span>Preview Data</span>
                            </button>
                            <button
                              onClick={(e) => {
                                e.stopPropagation()
                                clearFile()
                              }}
                              className="flex items-center space-x-2 px-6 py-3 text-red-600 hover:bg-red-50 rounded-xl transition-colors font-medium"
                            >
                              <X className="w-5 h-5" />
                              <span>Remove File</span>
                            </button>
                          </div>
                        </motion.div>
                      ) : (
                        <motion.div
                          key="upload-prompt"
                          initial={{ opacity: 0, scale: 0.8 }}
                          animate={{ opacity: 1, scale: 1 }}
                          exit={{ opacity: 0, scale: 0.8 }}
                          className="flex flex-col items-center"
                        >
                          <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mb-6">
                            <Upload className="w-10 h-10 text-slate-400" />
                          </div>
                          <h3 className="text-xl font-bold text-slate-900 mb-3">
                            Drop your CSV file here
                          </h3>
                          <p className="text-slate-600 mb-6 text-lg">or click to browse from your device</p>
                          <div className="flex items-center space-x-2 text-sm text-slate-500 bg-slate-100 px-4 py-2 rounded-full">
                            <Shield className="w-4 h-4" />
                            <span>Supports CSV files Only</span>
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </motion.div>

                  {/* Processing Button */}
                  <motion.div 
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2 }}
                    className="mt-10"
                  >
                    <button
                      onClick={handleSubmit}
                      disabled={!isFormValid() || loading}
                      className={`w-full py-5 px-8 rounded-2xl font-bold text-lg text-white transition-all duration-300 ${
                        !isFormValid() || loading
                          ? 'bg-slate-300 cursor-not-allowed transform-none shadow-none'
                          : 'bg-gradient-to-r from-indigo-600 via-purple-600 to-blue-600 hover:from-indigo-700 hover:via-purple-700 hover:to-blue-700 shadow-2xl hover:shadow-3xl transform hover:-translate-y-1 active:scale-95'
                      }`}
                    >
                      {loading ? (
                        <div className="flex items-center justify-center space-x-4">
                          <div className="w-6 h-6 border-3 border-white/30 border-t-white rounded-full animate-spin"></div>
                          <span>Processing Bulk Recharge... {Math.round(processedCount)}%</span>
                        </div>
                      ) : (
                        <div className="flex items-center justify-center space-x-3">
                          {/* <Zap className="w-6 h-6" /> */}
                          <span>Process Bulk Recharge</span>
                        </div>
                      )}
                    </button>

                    {!isFormValid() && (
                      <motion.p 
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        className="text-center text-slate-500 mt-4 text-sm"
                      >
                        Please fill in all required fields and upload a CSV file to continue
                      </motion.p>
                    )}
                  </motion.div>
                </div>

                {/* Progress Bar */}
                {loading && (
                  <div className="mt-8">
                    <div className="bg-slate-200 rounded-full h-3 overflow-hidden shadow-inner">
                      <motion.div
                        className="bg-gradient-to-r from-indigo-500 via-purple-500 to-blue-500 h-full rounded-full"
                        initial={{ width: 0 }}
                        animate={{ width: `${processedCount}%` }}
                        transition={{ duration: 0.5 }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </motion.div>
          </div>

          {/* Professional Side Panel */}
          <div className="space-y-8">
            {/* Format Guide */}
            <motion.div 
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2 }}
              className="bg-white rounded-3xl p-8 shadow-xl shadow-slate-200/50 border border-slate-200/60"
            >
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-10 h-10 bg-blue-100 rounded-xl flex items-center justify-center">
                  <FileText className="w-5 h-5 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-slate-900">CSV Format Requirements</h3>
              </div>
              <div className="space-y-4">
                <div className="flex items-center space-x-3 p-3 bg-emerald-50 rounded-lg border border-emerald-200">
                  <div className="w-3 h-3 bg-emerald-500 rounded-full"></div>
                  <span className="text-slate-700 font-medium"><strong>phone_number</strong> (required)</span>
                </div>
                <div className="flex items-center space-x-3 p-3 bg-emerald-50 rounded-lg border border-emerald-200">
                  <div className="w-3 h-3 bg-emerald-500 rounded-full"></div>
                  <span className="text-slate-700 font-medium"><strong>amount</strong> (required)</span>
                </div>
                <div className="flex items-center space-x-3 p-3 bg-blue-50 rounded-lg border border-blue-200">
                  <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                  <span className="text-slate-700 font-medium"><strong>network</strong> (required)</span>
                </div>
                <div className="flex items-center space-x-3 p-3 bg-blue-50 rounded-lg border border-blue-200">
                  <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
                  <span className="text-slate-700 font-medium"><strong>customer_reference</strong> (required)</span>
                </div>
              </div>
              <div className="mt-6 p-4 bg-slate-100 rounded-xl border-l-4 border-indigo-500">
                <p className="text-sm text-slate-700 font-mono">
                  <strong>Example:</strong><br />
                  +2348012345678,1000,MTN,REF001
                </p>
              </div>
            </motion.div>

            {/* Security & Compliance */}
            {/* <motion.div 
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.3 }}
              className="bg-gradient-to-br from-emerald-50 to-green-50 rounded-3xl p-8 border-2 border-emerald-200/60 shadow-lg"
            >
              <div className="flex items-center space-x-3 mb-4">
                <Shield className="w-6 h-6 text-emerald-600" />
                <h3 className="text-xl font-bold text-emerald-900">Enterprise Security</h3>
              </div>
              <div className="space-y-3 text-sm text-emerald-800">
                <div className="flex items-center space-x-2">
                  <CheckCircle className="w-4 h-4 text-emerald-600" />
                  <span>End-to-end encryption</span>
                </div>
                <div className="flex items-center space-x-2">
                  <CheckCircle className="w-4 h-4 text-emerald-600" />
                  <span>Automatic file deletion</span>
                </div>
                <div className="flex items-center space-x-2">
                  <CheckCircle className="w-4 h-4 text-emerald-600" />
                  <span>PCI DSS compliant</span>
                </div>
                <div className="flex items-center space-x-2">
                  <CheckCircle className="w-4 h-4 text-emerald-600" />
                  <span>Audit trail logging</span>
                </div>
              </div>
            </motion.div> */}

            {/* Performance Metrics */}
            {/* <motion.div 
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4 }}
              className="bg-gradient-to-br from-indigo-50 to-purple-50 rounded-3xl p-8 border-2 border-indigo-200/60 shadow-lg"
            >
              <div className="flex items-center space-x-3 mb-4">
                <TrendingUp className="w-6 h-6 text-indigo-600" />
                <h3 className="text-xl font-bold text-indigo-900">System Performance</h3>
              </div>
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <span className="text-indigo-800 font-medium">Processing Speed</span>
                  <span className="font-bold text-indigo-900 text-lg">1.2s/txn</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-indigo-800 font-medium">Success Rate</span>
                  <span className="font-bold text-emerald-600 text-lg">99.8%</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-indigo-800 font-medium">Uptime</span>
                  <span className="font-bold text-blue-600 text-lg">99.9%</span>
                </div>
              </div>
            </motion.div> */}
          </div>
        </div>
      </div>

      {/* Enhanced Toast Container */}
      <ToastContainer 
        position="top-right" 
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        toastClassName="!bg-white !text-slate-900 !shadow-2xl !border-2 !border-slate-200 !rounded-xl"
        bodyClassName="!font-medium"
        progressClassName="!bg-gradient-to-r !from-indigo-500 !to-purple-500"
      />
    </div>
  );
}

export default BulkRecharge;